import React from 'react';

const HomePage = () => (
  <div>
    <h1>Welcome to our page!</h1>
    <p>
      Lorem ipsum dolor sit amet consectetur, adipisicing elit.
      Illo commodi alias delectus soluta cupiditate
      tenetur doloremque animi enim itaque neque, eaque sapiente?
      Mollitia, quos temporibus facere veritatis ratione provident libero?
    </p>
    <p>
      Lorem ipsum dolor sit amet consectetur, adipisicing elit.
      Illo commodi alias delectus soluta cupiditate
      tenetur doloremque animi enim itaque neque, eaque sapiente?
      Mollitia, quos temporibus facere veritatis ratione provident libero?
    </p>
  </div>
);

export default HomePage;
